module.exports = __webpack_public_path__ + "static/OurStory-956633afda525bf69af2baa84880c299.png";